"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_MolecularSequence_StructureVariant = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_integer_1 = require("../Scalar/RTTI_integer");
var RTTI_MolecularSequence_Outer_1 = require("./RTTI_MolecularSequence_Outer");
var RTTI_MolecularSequence_Inner_1 = require("./RTTI_MolecularSequence_Inner");
exports.RTTI_MolecularSequence_StructureVariant = t.recursion('IMolecularSequence_StructureVariant', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        variantType: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        exact: t.boolean,
        _exact: RTTI_Element_1.RTTI_Element,
        length: RTTI_integer_1.RTTI_integer,
        _length: RTTI_Element_1.RTTI_Element,
        outer: RTTI_MolecularSequence_Outer_1.RTTI_MolecularSequence_Outer,
        inner: RTTI_MolecularSequence_Inner_1.RTTI_MolecularSequence_Inner
    });
});
//# sourceMappingURL=RTTI_MolecularSequence_StructureVariant.js.map